import { render } from "./paper2.vue?vue&type=template&id=24cdf594&scoped=true"
import script from "./paper2.vue?vue&type=script&lang=js"
export * from "./paper2.vue?vue&type=script&lang=js"

import "./paper2.vue?vue&type=style&index=0&id=24cdf594&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cdf594"]])

export default __exports__